/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seq: NonNullable<unknown> }} Gdpr_Audit_Verify_BadInputs */

const cs_gdpr_audit_verify_bad = /** @type {(inputs: Gdpr_Audit_Verify_BadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Řetězec porušen od záznamu č. ${i?.seq}!`)
};

const en_gdpr_audit_verify_bad = /** @type {(inputs: Gdpr_Audit_Verify_BadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chain broken from entry #${i?.seq}!`)
};

/**
* | output |
* | --- |
* | "Chain broken from entry #{seq}!" |
*
* @param {Gdpr_Audit_Verify_BadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_audit_verify_bad = /** @type {((inputs: Gdpr_Audit_Verify_BadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Audit_Verify_BadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_audit_verify_bad(inputs)
	return cs_gdpr_audit_verify_bad(inputs)
});